module.exports = __webpack_public_path__ + "img/img31.e6eceb41.png";